var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNexo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m30.994 24.645-6.475 3.736-15.4-8.798v-6.24l15.43 8.932v-1.349l6.444 3.72zM31 24.64l-6.45-3.715v-9.466L16.612 6.97 23.494 3l7.215 4.16a.606.606 0 0 1 .29.503v16.976zm-8.074-12.233L7.405 3.634 1 7.329v16.976a.606.606 0 0 0 .29.521l7.21 4.16v-7.889l-1.003-.573v-10l15.429 8.932v-7.05zM8.5 28.975v-7.877l6.854 3.917-6.854 3.96z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexo);
export default __webpack_public_path__ + "static/media/NEXO.3f494002910b079998ca3c596623ca95.svg";
export { ForwardRef as ReactComponent };